import type { SidebarMenuItem } from '@components/Sidebar'
import { matchPath } from 'react-router'

function withAsteriskSuffix(url: string) {
  if (url.endsWith('/*')) {
    return url
  } else if (url.endsWith('/')) {
    return url + '*'
  } else {
    return url + '/*'
  }
}

export function isMenuActive(location: string, menuItem: SidebarMenuItem): boolean {
  const activeUrl = location.split('?')[0]

  // A prefix match is not enough on its own: a sibling entry can own a deeper
  // route under the same prefix, which would otherwise light both pills at
  // once.
  if (menuItem.activeExcludeUrls) {
    for (const excludeUrl of menuItem.activeExcludeUrls) {
      const menuExcludeUrl = excludeUrl.split('?')[0]
      if (matchPath(withAsteriskSuffix(menuExcludeUrl), activeUrl)) {
        return false
      }
    }
  }

  if (menuItem.activeMatchUrls) {
    for (const activeMatchUrl of menuItem.activeMatchUrls) {
      const menuActiveMatchUrl = activeMatchUrl.split('?')[0]
      const isMatch = !!matchPath(withAsteriskSuffix(menuActiveMatchUrl), activeUrl)
      if (isMatch) {
        return isMatch
      }
    }
  }

  if (!menuItem.url) {
    return false
  }

  const menuItemUrl = menuItem.url.split('?')[0]
  return !!matchPath(menuItemUrl + '/*', activeUrl)
}
